import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Yandex = (props: TIconProps): ReactElement => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.379883 12C0.379883 5.55648 5.60188 0.333313 12.0466 0.333313C18.4889 0.333313 23.7132 5.55648 23.7132 12C23.7132 18.4435 18.4889 23.6666 12.0466 23.6666C5.60188 23.6666 0.379883 18.4435 0.379883 12Z"
      fill="#FC3F1D"
    />
    <path
      d="M13.5399 6.94367H12.4619C10.4856 6.94367 9.44611 7.94467 9.44611 9.42051C9.44611 11.0888 10.1648 11.8705 11.6406 12.8727L12.8598 13.694L9.35628 18.9288H6.73828L9.88245 14.2458C8.07412 12.9497 7.05911 11.6908 7.05911 9.56167C7.05911 6.89234 8.91995 5.07001 12.4491 5.07001H15.9526V18.916H13.5399V6.94367Z"
      fill="white"
    />
  </svg>
);
